var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTTable',{attrs:{"title":"Provincias","subtitle":"Lista de provincias","fields":_vm.fields,"items":_vm.$store.state.provincias.provincias},on:{"delete":function($event){return _vm.deleteItem($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }